import { combineReducers } from "redux";
import edisHoldingReducer from "./HoldingsReducer";
import historyReducer from "./HistoryReducer";
import reqIdHistory from "./ReqIdHistory";
export default combineReducers({
    edisHoldingReducer: edisHoldingReducer,
    historyReducer: historyReducer,
    reqIdHistory: reqIdHistory,
});
